<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-card outlined class="w-100 d-none d-md-block">
          <v-img
            contain
            src="@/assets/images/banner.png"
            alt="Banner inicio con logo de PBXBerry"
            class="w-100"
          ></v-img>
        </v-card>
        <v-card color="transparent" flat class="d-block d-md-none">
          <v-img
            contain
            src="@/assets/images/banner-mobile.png"
            alt="Banner inicio con logo de PBXBerry"
            class="w-100"
          ></v-img>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="d-none d-md-flex">
      <v-col cols="12" sm="6" lg="3">
        <v-card
          flat
          class="bg-0 d-flex align-center"
          height="100px"
          @click="$router.push({ name: 'Dashboard' })"
        >
          <v-list-item>
            <v-list-item-avatar tile>
              <img src="@/assets/images/home-buttons/1.png" alt="icon" />
            </v-list-item-avatar>

            <v-list-item-content class="white--text text-uppercase">
              <v-list-item-title>Dashboard</v-list-item-title>

              <v-list-item-subtitle class="text-caption white--text">
                Día / Mes
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <v-card
          flat
          class="bg-1 d-flex align-center"
          height="100px"
          @click="$router.push({ name: 'Informe de Cola' })"
        >
          <v-list-item>
            <v-list-item-avatar tile>
              <img src="@/assets/images/home-buttons/2.png" alt="icon" />
            </v-list-item-avatar>

            <v-list-item-content class="white--text text-uppercase">
              <v-list-item-title>Reporte colas</v-list-item-title>

              <v-list-item-subtitle class="text-caption white--text">
                Día / Mes / Año
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <v-card
          flat
          class="bg-2 d-flex align-center"
          height="100px"
          @click="$router.push({ name: 'Información de llamadas' })"
        >
          <v-list-item>
            <v-list-item-avatar tile>
              <img src="@/assets/images/home-buttons/3.png" alt="icon" />
            </v-list-item-avatar>

            <v-list-item-content class="white--text text-uppercase">
              <v-list-item-title>Reporte llamadas</v-list-item-title>

              <v-list-item-subtitle class="text-caption white--text">
                Día / Mes
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <v-card
          flat
          class="bg-3 d-flex align-center"
          height="100px"
          @click="$router.push({ name: 'CDR' })"
        >
          <v-list-item>
            <v-list-item-avatar tile>
              <img src="@/assets/images/home-buttons/4.png" alt="icon" />
            </v-list-item-avatar>

            <v-list-item-content class="white--text text-uppercase">
              <v-list-item-title>Grabaciones</v-list-item-title>

              <v-list-item-subtitle class="text-caption white--text">
                Registro detallado
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        v-show="[1, 2, 3, 7, 8].includes(Role)"
      >
        <v-card
          flat
          class="bg-4 d-flex align-center"
          height="100px"
          @click="$router.push({ name: 'Agentes creados' })"
        >
          <v-list-item>
            <v-list-item-avatar tile>
              <img src="@/assets/images/home-buttons/5.png" alt="icon" />
            </v-list-item-avatar>

            <v-list-item-content class="white--text text-uppercase">
              <v-list-item-title>Agentes</v-list-item-title>

              <v-list-item-subtitle class="text-caption white--text">
                Creados
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3" v-show="[1, 2, 3, 7, 8].includes(Role)">
        <v-card
          flat
          class="bg-5 d-flex align-center"
          height="100px"
          @click="$router.push({ name: 'Pausas activas' })"
        >
          <v-list-item>
            <v-list-item-avatar tile>
              <img src="@/assets/images/home-buttons/6.png" alt="icon" />
            </v-list-item-avatar>

            <v-list-item-content class="white--text text-uppercase">
              <v-list-item-title>Agentes</v-list-item-title>

              <v-list-item-subtitle class="text-caption white--text">
                En pausa
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3" v-show="[1, 2, 3, 7, 8].includes(Role)">
        <v-card
          flat
          class="bg-6 d-flex align-center"
          height="100px"
          @click="$router.push({ name: 'Configurar Campañas' })"
        >
          <v-list-item>
            <v-list-item-avatar tile>
              <img src="@/assets/images/home-buttons/7.png" alt="icon" />
            </v-list-item-avatar>

            <v-list-item-content class="white--text text-uppercase">
              <v-list-item-title>Campañas</v-list-item-title>

              <v-list-item-subtitle class="text-caption white--text">
                Configuración
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3" v-show="[1, 2].includes(Role)">
        <v-card
          flat
          class="bg-7 d-flex align-center"
          height="100px"
          @click="OPENSMSDIALOG"
        >
          <v-list-item>
            <v-list-item-avatar tile>
              <img src="@/assets/images/home-buttons/8.png" alt="icon" />
            </v-list-item-avatar>

            <v-list-item-content class="white--text text-uppercase">
              <v-list-item-title>SMS</v-list-item-title>

              <v-list-item-subtitle class="text-caption white--text">
                Nuevo mensaje
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="d-flex d-md-none">
      <v-col cols="6" sm="4">
        <v-card
          flat
          class="bg-0 d-flex flex-column text-center"
          @click="$router.push({ name: 'Dashboard' })"
        >
          <v-responsive aspect-ratio="1" class="align-center">
            <v-avatar tile>
              <img src="@/assets/images/home-buttons/1.png" alt="icon" />
            </v-avatar>
            <v-list-item>
              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Dashboard</v-list-item-title>

                <v-list-item-subtitle class="text-caption white--text">
                  Día / Mes
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-responsive>
        </v-card>
      </v-col>

      <v-col cols="6" sm="4">
        <v-card
          flat
          class="bg-1 d-flex flex-column  text-center"
          @click="$router.push({ name: 'Informe de Cola' })"
        >
          <v-responsive aspect-ratio="1" class="align-center">
            <v-avatar tile>
              <img src="@/assets/images/home-buttons/2.png" alt="icon" />
            </v-avatar>
            <v-list-item>
              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Reporte colas</v-list-item-title>

                <v-list-item-subtitle class="text-caption white--text">
                  Día / Mes / Año
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-responsive>
        </v-card>
      </v-col>

      <v-col cols="6" sm="4">
        <v-card
          flat
          class="bg-2 d-flex text-center"
          @click="$router.push({ name: 'Información de llamadas' })"
        >
          <v-responsive aspect-ratio="1" class="align-center">
            <v-avatar tile>
              <img src="@/assets/images/home-buttons/3.png" alt="icon" />
            </v-avatar>

            <v-list-item>
              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title class="text-caption"
                  >Reporte llamadas</v-list-item-title
                >

                <v-list-item-subtitle class="text-caption white--text">
                  Día / Mes
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-responsive>
        </v-card>
      </v-col>

      <v-col cols="6" sm="4">
        <v-card
          flat
          class="bg-3 d-flex text-center"
          @click="$router.push({ name: 'CDR' })"
        >
          <v-responsive aspect-ratio="1" class="align-center">
            <v-avatar tile>
              <img src="@/assets/images/home-buttons/4.png" alt="icon" />
            </v-avatar>
            <v-list-item>
              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Grabaciones</v-list-item-title>

                <v-list-item-subtitle class="text-caption white--text">
                  Registro detallado
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-responsive>
        </v-card>
      </v-col>

      <v-col cols="6" sm="4" v-show="[1, 2, 3, 7, 8].includes(Role)">
        <v-card
          flat
          class="bg-4 d-flex text-center"
          @click="$router.push({ name: 'Agentes creados' })"
        >
          <v-responsive aspect-ratio="1" class="align-center">
            <v-avatar tile>
              <img src="@/assets/images/home-buttons/5.png" alt="icon" />
            </v-avatar>
            <v-list-item>
              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Agentes</v-list-item-title>

                <v-list-item-subtitle class="text-caption white--text">
                  Creados
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-responsive>
        </v-card>
      </v-col>

      <v-col cols="6" sm="4" v-show="[1, 2, 3, 7, 8].includes(Role)">
        <v-card
          flat
          class="bg-5 d-flex text-center"
          @click="$router.push({ name: 'Pausas activas' })"
        >
          <v-responsive aspect-ratio="1" class="align-center">
            <v-avatar tile>
              <img src="@/assets/images/home-buttons/6.png" alt="icon" />
            </v-avatar>
            <v-list-item>
              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Agentes</v-list-item-title>

                <v-list-item-subtitle class="text-caption white--text">
                  En pausa
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-responsive>
        </v-card>
      </v-col>

      <v-col cols="6" sm="4" v-show="[1, 2, 3, 7, 8].includes(Role)">
        <v-card
          flat
          class="bg-6 d-flex text-center"
          @click="$router.push({ name: 'Configurar Campañas' })"
        >
          <v-responsive aspect-ratio="1" class="align-center">
            <v-avatar tile>
              <img src="@/assets/images/home-buttons/7.png" alt="icon" />
            </v-avatar>
            <v-list-item>
              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Campañas</v-list-item-title>

                <v-list-item-subtitle class="text-caption white--text">
                  Configuración
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-responsive>
        </v-card>
      </v-col>

      <v-col cols="6" sm="4" v-show="[1, 2].includes(Role)">
        <v-card
          flat
          class="bg-7 d-flex text-center"
          @click="OPENSMSDIALOG"
        >
          <v-responsive aspect-ratio="1" class="align-center">
            <v-avatar tile>
              <img src="@/assets/images/home-buttons/8.png" alt="icon" />
            </v-avatar>
            <v-list-item>
              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>SMS</v-list-item-title>

                <v-list-item-subtitle class="text-caption white--text">
                  Nuevo mensaje
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-responsive>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";


export default {
  data() {
    return {
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4"
      ],
      slides: ["First", "Second", "Third", "Fourth", "Fifth"]
    };
  },

  computed: {
    Role() {
      return this.$store.getters["passport/GET_ROLE"];
    }
  },

  methods: {
    ...mapActions('user', ['OPENSMSDIALOG']),
  }
};
</script>

<style>
.bg-0,
.bg-3,
.bg-5 {
  background-image: linear-gradient(to right, #7c5cf5ff 0%, #9b8bf7ff 100%);
}
.bg-0:hover,
.bg-3:hover,
.bg-5:hover {
  background-image: linear-gradient(to right, #513996ff 0%, #916ddcff 100%);
}
.bg-1,
.bg-6 {
  background-image: linear-gradient(to right, #6ad4d4ff 0%, #1ac2ccff 100%);
}
.bg-1:hover,
.bg-6:hover {
  background-image: linear-gradient(to right, #4cabb8ff 0%, #0084baff 100%);
}
.bg-2,
.bg-4,
.bg-7 {
  background-image: linear-gradient(to right, #5672ddff 0%, #428de0ff 100%);
}
.bg-2:hover,
.bg-4:hover,
.bg-7:hover {
  background-image: linear-gradient(to right, #5434a2ff 0%, #4f76d8ff 100%);
}
</style>
